import { render, staticRenderFns } from "./email.vue?vue&type=template&id=993646de&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('993646de')) {
      api.createRecord('993646de', component.options)
    } else {
      api.reload('993646de', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=993646de&", function () {
      api.rerender('993646de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/email.vue"
export default component.exports